export default __webpack_public_path__ + "static/media/profiles.4f64ae67.svg";